<div class="timer"></div>
<div class="content">
    <fa-icon *ngIf="dismiss" [icon]="faTimes" class="primary" (click)="close()"></fa-icon>
    <h4>{{title}}</h4>
    <p>{{text}}</p>
    <button class="mpro-btn" [color]="buttonColor" [hue]="buttonHue" mproButtton="tertiary" (click)="onClick()">Create</button>
</div>
